import type { ColumnDef } from '@/shared/types/table-filters.types';
import type { Verification, VerificationStatus } from '../types/verification.types';
import { VERIFICATION_STATUS_CONFIG } from '../types/verification.types';

const VERIFICATION_STATUSES: VerificationStatus[] = [
  'DRAFT',
  'SENT',
  'ACCEPTED',
  'REJECTED',
  'TIMED_OUT',
  'VERIFIED',
  'RETURNED',
];

// Reuses the badge labels so the filter and the table never drift apart.
const VERIFICATION_STATUS_LABELS: Record<string, string> = Object.fromEntries(
  VERIFICATION_STATUSES.map((status) => [status, VERIFICATION_STATUS_CONFIG[status].label])
);

/** Filterable/sortable verification fields, shared by the desktop table and the mobile cards. */
export const verificationTableColumns: ColumnDef<Verification>[] = [
  {
    key: 'refereeName',
    label: 'Reference contact',
    filterType: 'text',
    accessor: (verification) => verification.refereeName,
    sortable: true,
  },
  {
    key: 'refereeEmail',
    label: 'Email',
    filterType: 'text',
    accessor: (verification) => verification.refereeEmail,
    sortable: true,
  },
  {
    key: 'refereeJobTitle',
    label: 'Job title',
    filterType: 'text',
    accessor: (verification) => verification.refereeJobTitle,
    sortable: true,
  },
  {
    key: 'status',
    label: 'Status',
    filterType: 'select',
    accessor: (verification) => verification.status,
    options: VERIFICATION_STATUSES,
    optionLabels: VERIFICATION_STATUS_LABELS,
    sortable: true,
  },
  {
    key: 'sentAt',
    label: 'Sent',
    filterType: 'date-range',
    accessor: (verification) => verification.sentAt,
    sortable: true,
  },
  {
    key: 'createdAt',
    label: 'Created',
    filterType: 'date-range',
    accessor: (verification) => verification.createdAt,
    sortable: true,
  },
];
